// Main drills index - combines all sport-specific drill files
// This keeps the context manageable while maintaining all drill data

import soccerDrills from './soccer-drills.js';
import soccerPartnerDrills from './soccer-drills-partner.js';
import martialArtsDrills from './martial-arts-drills.js';
import danceDrills from './dance-drills.js';
import basketballDrills from './basketball-drills.js';
import karateDrills from './karate-drills.js';
import volleyballDrills from './volleyball-drills.js';
import volleyballPartnerDrills from './volleyball-drills-partner.js';
import movementCoordinationDrills from './movement-coordination-drills.js';
import balletDrills from './ballet-drills.js';
import boxingDrills from './boxing-drills.js';
import yogaDrills from './yoga-drills.js';
import taekwondoDrills from './taekwondo-drills.js';
import baseballDrills from './baseball-drills.js';
import baseballPartnerDrills from './baseball-drills-partner.js';
import runningTechniqueDrills from './running-technique-drills.js';

// Combine all drills into one array
const allDrills = [
  ...soccerDrills,
  ...soccerPartnerDrills,
  ...martialArtsDrills,
  ...danceDrills,
  ...basketballDrills,
  ...karateDrills,
  ...volleyballDrills,
  ...volleyballPartnerDrills,
  ...movementCoordinationDrills,
  ...balletDrills,
  ...boxingDrills,
  ...yogaDrills,
  ...taekwondoDrills,
  ...baseballDrills,
  ...baseballPartnerDrills,
  ...runningTechniqueDrills,
];

export default allDrills;
